import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from '../components/layout/Sidebar';
import { FeedbackWidget } from '../components/ui/FeedbackWidget';
import { useAuth } from '../context/AuthContext';

export const DashboardPage: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="flex h-screen overflow-hidden bg-white">
      <Sidebar />
      <main className="flex-1 flex flex-col h-screen overflow-hidden bg-slate-50 relative">
        <div className="flex-1 overflow-y-auto p-4 md:p-8 pb-24">
           <Outlet />
        </div>
      </main>
      {user && <FeedbackWidget user={user} />}
    </div>
  );
};
